import { List, ListItemButton, Skeleton, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

const LoadingSkeleton = ({ len }) => {
  //   const [items, setitems] = useState([]);

  //   useEffect(() => {
  //     if (len > 0) {
  //       const data = getIterations(len);
  //       setitems(data);
  //     }
  //   }, [len]);
  //   const getIterations = (i) => {
  //     let items = [];
  //     for (let index = 0; index < i; index++) {
  //       items.push(index);
  //     }
  //     return items;
  //   };

  const items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return items.length > 0 ? (
    items.map((data, index) => (
      <ListItemButton key={index} sx={{ alignItems: "start" }}>
        <Skeleton animation="wave" variant="circular" width={50} height={40} />
        <Stack direction="column" width="100%">
          <Skeleton
            animation="wave"
            height={20}
            width="100%"
            style={{ marginBottom: 6, marginLeft: 6 }}
          />
          <Skeleton
            animation="wave"
            height={10}
            width="70%"
            style={{ marginBottom: 6, marginLeft: 6 }}
          />
          <Skeleton
            animation="wave"
            height={10}
            width="40%"
            style={{ marginBottom: 6, marginLeft: 6 }}
          />
        </Stack>
      </ListItemButton>
    ))
  ) : (
    <></>
  );
};

export default LoadingSkeleton;
